export enum SourcingPage {
  COMPARISON_PAGE = 'comparison',
  CART_PAGE = 'user-to-buy',
  HIDDEN_PAGE = 'user-hidden',
  FAVORITES_PAGE = 'user-favourite',
  CARVAGO_BUY_PAGE = 'user-carvago-buy',
  DEFAULT = '',
}
